<template>
  <div>
    <v-data-table 
      id="device-config-table"
      v-show="rows.length"
      :headers="headers"
      :items="rows"
      hide-default-footer
      disable-sort>
      <template slot="item" slot-scope="props">
        <tr>
          <td>                
            <select-with-button
              class="inputField"
              v-model="props.item.type"
              :items="DEV_CONFIG_TYPES"
              name="devConfigInput.type"
              style="margin-top: 15px;"/>
          </td>
             
          <td>   
            <v-text-field
              class="inputField"
              type="text"
              name="devConfigInput.value"
              v-model="props.item.value"
              style="margin-top: 15px;"
              solo/></td>
            
          <td>
            <v-text-field
              class="inputField"
              type="text"
              name="devConfigInput.description"
              v-model="props.item.description"
              style="margin-top: 15px;"
              solo/></td>
            
          <td>
            <v-btn text
              @click="$emit('addRow')" 
              style="padding-left: 0px"
              v-if="props.item.id == rows.length">
              <v-avatar size="30" class="mr-1">
                <img :src="addIcon" />
              </v-avatar>Add Row
            </v-btn>
            <v-btn text
              @click="$emit('deleteRow', props.item.id)" 
              style="padding-left: 0px">
              <v-avatar size="30" class="mr-1">
                <img :src="deleteIcon" />
              </v-avatar>Delete Row
            </v-btn>
          </td>
        </tr>                        
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  DEV_CONFIG_TYPES
} from "../../config/config.js";
import selectWithButton from "../../components/controls/SelectWithButton";

export default {
  name: "addDeviceConfigTable",
  props: {
    rows: Array
  },
  components: {
    selectWithButton
  },
  data() {
    return {
      DEV_CONFIG_TYPES: DEV_CONFIG_TYPES,
      lengthRegex: new RegExp(/^(?=.{1,100}$)/),
      headers: [
        {text: "Type", value:"Type"}, 
        {text: "Value", value:"Value"}, 
        {text: "Description", value:"Description"}
      ]
    };
  },
  computed: {
    addIcon() {
      return require("../../assets/" + this.coloredAssetUrls.addPatient);
    },
    deleteIcon() {
      return require("../../assets/" + this.coloredAssetUrls.removeImages);
    }
  }
};
</script>

<style lang="scss">
#device-config-table {
  .v-data-table__wrapper{
    overflow-y: auto !important;
    min-height: 160px;
    padding-bottom: 50px;
  }
}
</style>